import React from 'react';
import { NavLink } from 'react-router-dom';

import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';

import LocaleMessage from '~/components/LocaleMessage';

const useStyles = makeStyles(theme => {
    return {
        content: {
            width: '100%',
            textAlign: 'center',
        },
        pluginspace: {
            backgroundColor: theme.palette.primary.main,
        },
        title: {
            color: '#212529',
            fontSize: '70px',
            fontWeight: '600',
        },
    };
});

export default function Forbidden({ showHome, body }) {
    const classes = useStyles();

    return (
        <div className="app-wrapper">
            <div className="app-wrapper page-error-container animated slideInUpTiny animation-duration-3">
                <div className={`page-error-content ${classes.content}`}>
                    <div
                        className="error-code mb-4 animated zoomInDown"
                        style={{ textAlign: 'center' }}
                    >
                        <span className={`${classes.title}`}>
                            <LocaleMessage msg="message.forbidden.title" />
                        </span>
                    </div>
                    <h2 className="text-center fw-regular title bounceIn animation-delay-10 animated">
                        <span>
                            <LocaleMessage msg="message.forbidden.content" />
                        </span>
                    </h2>
                    {showHome ? (
                        <p className="text-center zoomIn animation-delay-10 animated">
                            <NavLink
                                className={`btn ${classes.pluginspace}`}
                                to="/home"
                            >
                                <span style={{ color: '#fff' }}>
                                    <LocaleMessage msg="message.go_home.title" />
                                </span>
                            </NavLink>
                        </p>
                    ) : null}
                    {body || null}
                </div>
            </div>
        </div>
    );
}

Forbidden.propTypes = {
    showHome: PropTypes.bool,
    body: PropTypes.element,
};

Forbidden.defaultProps = {
    showHome: true,
    body: null,
};
